import axios from "axios";

const VEHICLE_URI_PREFIX = "/v1/vehicle";
export const VEHICLE_URIS = {
  GET_LIST_VEHICLE: `${VEHICLE_URI_PREFIX}/list`,
  GET_LIST_HISTORY_ALL_VEHICLE: `${VEHICLE_URI_PREFIX}/history`,
  GET_LIST_HISTORY_VEHICLE: (vehicleId) =>
    `${VEHICLE_URI_PREFIX}/${vehicleId}/history`,
  EXPORT_LIST_VEHICLE: `${VEHICLE_URI_PREFIX}/export`,
  EXPORT_ASSIGN_VEHICLE: `${VEHICLE_URI_PREFIX}/export-assign-vehicle`,
  ADD_VEHICLE: `${VEHICLE_URI_PREFIX}/add`,
  EDIT_VEHICLE: `${VEHICLE_URI_PREFIX}/edit`,
  GET_VEHICLE_BY_ID: (vehicleId) => `${VEHICLE_URI_PREFIX}/${vehicleId}/detail`,
  GET_VEHICLE_TYPE: `${VEHICLE_URI_PREFIX}/type`,
  GET_FUEL_TYPE: `${VEHICLE_URI_PREFIX}/fuel-type`,
  SET_VEHICLE_STATUS: `${VEHICLE_URI_PREFIX}/set-status`,
  GET_LIST_IMPORT_CONFIRM: `${VEHICLE_URI_PREFIX}/duplicate`,
  IMPORT_CONTINUE: `${VEHICLE_URI_PREFIX}/continue`,
  GET_ALL_INSURANCE_COMPANY: `${VEHICLE_URI_PREFIX}/get-all-insurance-company`,
};

const TRAILER_URI_PREFIX = "/v1/trailer";
export const TRAILER_URIS = {
  GET_LIST_TRAILER: `${TRAILER_URI_PREFIX}/list`,
  IMPORT_CONTINUE: `${TRAILER_URI_PREFIX}/continue`,
  DOWNLOAD_ERROR_FILES: `${TRAILER_URI_PREFIX}/download-error-file`,
  EXPORT_LIST_TRAILER: `${TRAILER_URI_PREFIX}/export`,
  IMPORT_LIST_TRAILER: `${TRAILER_URI_PREFIX}/import`,
  ADD_TRAILER: `${TRAILER_URI_PREFIX}`,
  EDIT_TRAILER_BY_ID: (pid) => `${TRAILER_URI_PREFIX}/${pid}`,
  GET_TRAILER_BY_ID: (trailerId) => `${TRAILER_URI_PREFIX}/detail/${trailerId}`,
  DELETE_TRAILER: (trailerId) => `${TRAILER_URI_PREFIX}/${trailerId}`,
  GET_LIST_IMPORT_CONFIRM: `${TRAILER_URI_PREFIX}/get-list-override`,
  GET_TRAILER_TYPE: `${TRAILER_URI_PREFIX}/get-trailer-type`,
};

export default {
  deleteTrailer(pid) {
    return axios.delete(TRAILER_URIS.DELETE_TRAILER(pid));
  },
  getTrailer(id) {
    return axios.get(TRAILER_URIS.GET_LIST_TRAILER, { params, signal });
  },
  getListTrailer(params, signal) {
    return axios.get(TRAILER_URIS.GET_LIST_TRAILER, { params, signal });
  },
  getTrailerById(id) {
    return axios.get(TRAILER_URIS.GET_TRAILER_BY_ID(id));
  },
  getTrailerType(params) {
    return axios.get(TRAILER_URIS.GET_TRAILER_TYPE, { params });
  },
  editTrailer(data) {
    return axios.put(TRAILER_URIS.EDIT_TRAILER_BY_ID(data.pid), data);
  },
  addTrailer(data) {
    return axios.post(TRAILER_URIS.ADD_TRAILER, data);
  },
  getListVehicle(params, signal) {
    return axios.get(VEHICLE_URIS.GET_LIST_VEHICLE, { params, signal });
  },
  getHistoryAllVehicle(params) {
    return axios.get(VEHICLE_URIS.GET_LIST_HISTORY_ALL_VEHICLE, { params });
  },
  getHistoryOfVehicle(params) {
    const { vehicleId, ...rest } = params;
    return axios.get(VEHICLE_URIS.GET_LIST_HISTORY_VEHICLE(vehicleId), {
      params: rest,
    });
  },
  setVehicleStatus(data) {
    return axios.post(VEHICLE_URIS.SET_VEHICLE_STATUS, data);
  },
  exportListVehicle(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${
      VEHICLE_URIS.EXPORT_LIST_VEHICLE
    }?${searchParams.toString()}`;
    window.open(link);
  },
  exportListTrailer(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${
      TRAILER_URIS.EXPORT_LIST_TRAILER
    }?${searchParams.toString()}`;
    window.open(link);
  },
  exportAssignVehicle(params) {
    const link = `${
      VEHICLE_URIS.EXPORT_ASSIGN_VEHICLE
    }?lstId=${params.toString()}`;
    console.log("log");
    window.open(link);
  },
  getMasterDataVehicle() {
    return Promise.all([]).then((responses) => {
      return responses.map((response) => response.data.items);
    });
  },
  addVehicle(data) {
    return axios.post(VEHICLE_URIS.ADD_VEHICLE, data);
  },
  getVehicleById(id) {
    return axios.get(VEHICLE_URIS.GET_VEHICLE_BY_ID(id));
  },
  editVehicle(data) {
    return axios.put(VEHICLE_URIS.EDIT_VEHICLE, data);
  },
  importListVehicle(params) {
    return axios.post(`/v1/vehicle/importv2`, params);
  },
  importListTrailer(params) {
    return axios.post(TRAILER_URIS.IMPORT_LIST_TRAILER, params);
  },
  downloadErrorVehicleFile(errorId) {
    return axios.get("/v1/vehicle/download-error-file", {
      responseType: "arraybuffer",
      params: {
        errorId,
      },
    });
  },
  downloadErrorTrailerFile(errorId) {
    return axios.get(TRAILER_URIS.DOWNLOAD_ERROR_FILES, {
      responseType: "arraybuffer",
      params: {
        errorId,
      },
    });
  },
  getVehicleType() {
    return axios.get(VEHICLE_URIS.GET_VEHICLE_TYPE);
  },
  getListConfirmImportVehicle(params) {
    return axios.get(VEHICLE_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  getListConfirmImportTrailer(params) {
    return axios.get(TRAILER_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  importContinueVehicle(data) {
    return axios.post(VEHICLE_URIS.IMPORT_CONTINUE, data);
  },
  importContinueTrailer(data) {
    return axios.post(TRAILER_URIS.IMPORT_CONTINUE, data);
  },
  getInsuranceCompanyName() {
    return axios.get(VEHICLE_URIS.GET_ALL_INSURANCE_COMPANY);
  },
  getFuelType(){
    return axios.get(VEHICLE_URIS.GET_FUEL_TYPE);
  }
};



// WEBPACK FOOTER //
// ./src/services/vehicle-service.js